import _ from 'lodash';
import { textinputValidators } from './textinputValidators';
import { pageNameValidator, legacyPageNameValidator, pagesFolderNameValidator, } from './pageValidators';
import { menuItemNameValidator } from './menuValidators';
import { widgetNameValidator } from './widgetValidators';
import { validateAddress } from './googleMapsValidator';
import * as utils from './utils';
const validators = _.assign({}, textinputValidators, { pageNameValidator, legacyPageNameValidator, pagesFolderNameValidator }, { menuItemNameValidator }, { widgetNameValidator }, { validateAddress }, { utils });
export default validators;
